export const localeMessage = {
  en: {
    changePriceTo: `Change price to`,
    successfullyCollected: `Successfully Collected`,
    result: `Result`,
    mustEnterAtLeastOneAt: `You must enter at least one at the beginning or end`,
    editMasterSkuMass: `Mass edit master SKU`,
    atTheBeginningAdd: `Add at the beginning`,
    increaseStartingValueAutomatically: `Automatically increase starting value`,
    atTheEndAdd: `Add at the end`,
    preview: `Preview`,
    xxWithYyyReplace: `Replace xx with yyy`,
    rangeIsThe: `The range is 0-999,999`,
    draft: `Draft`,
    editUnitPurchasePriceMass: `Mass edit unit purchase price`,
    editDefaultPriceMass: `Mass edit default price`,
    editAvailableStockMass: `Mass edit available stock`,
    massEdit: `Mass edit`,
    percentageLimit: `The percentage range should be 0-100000`,
    PriceLimit: `Price Should be between 0-1,000,000,000!`,
    time: `Time`,
    category: `Category`,
    updateTime: `Update time`,
    search: `Search`,
    clear: `Clear`,
    filter: `Filter`,
    keyword: `keyword`,
    scrapingSettings: `Scraping settings`,
    scrapingSettingsTip: `After setting up the auto collect to Master Product List, the successfully scraped products will be automatically collected to Master Product List, and automatically brought into the sales price according to the price rules`,
    priceSetting: `Price setting`,
    priceSettingTip: `Price rules based on original price`,
    priceSettingDes1: `Keep the Original Price`,
    addByAmount: `Add by amount`,
    addByPercent: `Add by percent`,
    reduceByAmount: `Reduce by amount`,
    reduceByPercent: `Reduce by percent`,
    noChange: `No Change`,
    cancel: `cancel`,
    confirm: `confirm`,
    amount: `Amount`,
    scrapeList: `Scrape List`,
    scrapeProducts: `Scrape Products`,
    copyToChannel: `Continue Copy to Channel`,
    editPublish: `Edit Publish`,
    productScraping: `Product Scraping`,
    categoryScraping: `Category Scraping`,
    storeScraping: `Store Scraping`,
    enterTip1: `Please fill in the Product URL, please use Enter to wrap for multiple URLs, Max.1000`,
    enterTip2: `Please fill in the classified website in the shop. If you want to enter multiple websites, please use Enter to wrap. Max.100`,
    enterTip3: `Please fill in the Shopee store link address. For multiple URLs, please use Enter to change lines. Max.1000`,
    supportChannelsTip: `Support channels: `,
    collectSettings: `Collect Settings`,
    scraping: `Scraping`,
    allScrapingSuccess: `All Scraping Success`,
    allScrapingFailed: `All Scraping Failed`,
    someScrapingFailed: `Some Scraping Failed`,
    totalNumber: `Total number`,
    successNumber: `Success Number`,
    failedNumber: `Failed Number`,
    failedUrl: `Failed URL`,
    validNumber: `Valid Link`,
    invalidNumber: `Invalid Link`,
    scrapingFailed: `Product Scraping failed`,
    productName: `product name`,
    sku: `SKU`,
    productUrl: `Product URL`,
    creator: `Creator`,
    pleaseEnterContent: `Please enter content`,
    dataSources: `Data Sources`,
    createTime: `Create time`,
    today: `Today`,
    weekly: `Weekly`,
    monthly: `Monthly`,
    yearly: `Yearly`,
    reset: `Reset`,
    all: `All`,
    notCollected: `Not Collected`,
    collected: `Collected`,
    price: `price`,
    noData: `No data`,
    xDataSelected: `X data selected`,
    collect: `Collect`,
    delete: `delete`,
    operationGuide: `Operation guide`,
    deleteTip1: `Confirm to delete the selected products in the Scrape List?`,
    deleteTip2: `The selected products will not be deleted in the channel, please delete them yourself`,
    ScrapingInProcess: `Scraping in process, Please wait.`,
    ClickTip: `Click on the information in the table to edit.`,
    productNameImage: `Product Name&Image`,
    variantName: `Variant Name`,
    masterSKU: `Master SKU`,
    availableStock: `Available Stock`,
    defaultPrice: `Default price`,
    unitPurchasePrice: `Unit Purchase Price`,
    action: `Action`,
    discardChangeTip: `Are sure you want to discard this change?`,
    viewNow: `View Now`,
    scrapeManagement: `Scrape Management`,
    mskuExistsTip: `Master SKU already exists, please rename`,
    collectedResultTip: `3 products has been collected to Master Product`,
    deletedResultTip1: `Successfully deleted`,
    deletedResultTip2: `65 data have been deleted`,
    ScrapingInProcessDec: `The store products are being scraped, and each store is going to take around 10 minutes. You can continue to scrape other stores or go to the collection list to view the collected products.`,
    continueToScrape: `Continue to scrape`,
    collectToMasterProduct: `Collect to Master Product`,
    collectToMasterProductDec: `After collecting the Master Product, publish it to the channel store so you can start manage price and inventory`,
    autoCollectToMp: `Auto Collect to Master product`,
    selectProducts: `Select Products and collect in mass`,
    autoCollectToMpLimit: `When the inventory of the scraped product is 0, auto-collect will not be supported`,
    inventorySkuLimit: `Master SKU should be less than 50character`,
    iskuCannotBeEmpty: `Master SKU cannot be empty!`,
    purchasePriceLimit: `Price Should be between 0-1,000,000,000!`,
    addAvailableStockLimit: `Available Stock should be between1-999,999`,
    productNameLimit: `Product Name must be between 1 - 300 characters`,
    findSource: `Find source`,
    editDec: `Edit and publish from the draft in the Store`,
    scrapeProduct: `Scrape Product`,
    inputLinkTip: `Input link to Scrape Products`,
    collectToMasterDec: `Collect and create Master Products in mass`,
    copyToStoreTip2: `Copy to Store to sell`,
    copyToStoreTip3: `Select Store and copy Master Product as draft in Store`,
    close: `Close`,
    allLinksInvalid: `All links are invalid, please check`,
    someLinksInvalid: `Some links are invalid, please check`,
    viewMore: `View more`,
    viewLess: `View less`,
    faqName: `How to clone the Master product to the channel store`,
    faqName1: `How to collect products from Shopee channels?`,
    recommendToUseTheScrapePlugin: `We recommend to use the Scrape extension, this feature is more stable and faster!`,
    recommendToUseTheScrapePluginTip1: `1. Recommended browser: Google Chrome!`,
    recommendToUseTheScrapePluginTip2: `2. Extension installation address:`,
    recommendToUseTheScrapePluginTip2Sub: `Go to the google store to install`,
    recommendToUseTheScrapePluginTip3: `3. When you can't access the Google Store, download the extension
 here:`,
    recommendToUseTheScrapePluginTip3Sub: `Download and Install Extension`,
    recommendToUseTheScrapePluginTip4: `4. For how to use the extension, please refer to:`,
    recommendToUseTheScrapePluginTip4Sub: `Using the tutorial`,
    pluginScraping: `Scrape Extension`,
    scrapeSuccess: `Scrape Success`,
    scrapeFailedPleaseCheckLinkOr: `Scrape Failed ,Please check link or try again later`,
    installTheTutorial: `Install the tutorial`
  },
  zh: {
    changePriceTo: `\u76F4\u63A5\u5C06\u4EF7\u683C\u6539\u6210`,
    successfullyCollected: `\u8BA4\u9886\u6210\u529F`,
    result: `\u7ED3\u679C`,
    mustEnterAtLeastOneAt: `\u60A8\u5FC5\u987B\u81F3\u5C11\u5728\u5F00\u5934\u6216\u7ED3\u5C3E\u4E2D\u8F93\u5165\u4E00\u4E2A`,
    editMasterSkuMass: `\u6279\u91CF\u7F16\u8F91\u4E3BSKU`,
    atTheBeginningAdd: `\u5F00\u5934\u6DFB\u52A0`,
    increaseStartingValueAutomatically: `\u81EA\u52A8\u589E\u957F\u5F00\u59CB\u503C`,
    atTheEndAdd: `\u7ED3\u5C3E\u6DFB\u52A0`,
    preview: `\u9884\u89C8`,
    xxWithYyyReplace: `\u5C06xx\u66FF\u6362\u6210yyy`,
    rangeIsThe: `\u8303\u56F4\u662F0-999,999`,
    draft: `\u8349\u7A3F\u7BB1`,
    editUnitPurchasePriceMass: `\u6279\u91CF\u7F16\u8F91\u91C7\u8D2D\u5355\u4EF7`,
    editDefaultPriceMass: `\u6279\u91CF\u7F16\u8F91\u9ED8\u8BA4\u552E\u4EF7`,
    editAvailableStockMass: `\u6279\u91CF\u7F16\u8F91\u53EF\u7528\u5E93\u5B58`,
    massEdit: `\u6279\u91CF\u7F16\u8F91`,
    percentageLimit: `\u767E\u5206\u6BD4\u8303\u56F4\u5E94\u662F0-100,000`,
    PriceLimit: `\u91D1\u989D\u5FC5\u987B\u57280 \u301C 1,000,000,000\u4E4B\u95F4\uFF01`,
    time: `\u65F6\u95F4`,
    category: `\u7C7B\u76EE`,
    updateTime: `\u66F4\u65B0\u65F6\u95F4`,
    search: `\u641C\u7D22`,
    clear: `\u6E05\u7A7A`,
    filter: `\u7B5B\u9009`,
    keyword: `\u5173\u952E\u8BCD`,
    scrapingSettings: `\u91C7\u96C6\u8BBE\u7F6E`,
    scrapingSettingsTip: `\u8BBE\u7F6E\u81EA\u52A8\u8BA4\u9886\u5230\u4E3B\u5546\u54C1\u5217\u8868\u540E\uFF0C\u91C7\u96C6\u6210\u529F\u7684\u5546\u54C1\u4F1A\u81EA\u52A8\u8BA4\u9886\u5230\u8BA4\u9886\u5230\u4E3B\u5546\u54C1\u5217\u8868\uFF0C\u5E76\u6839\u636E\u4EF7\u683C\u89C4\u5219\u81EA\u52A8\u5E26\u5165\u9500\u552E\u4EF7`,
    priceSetting: `\u4EF7\u683C\u8BBE\u7F6E`,
    priceSettingTip: `\u57FA\u4E8E\u539F\u4EF7\u7684\u52A0\u4EF7\u89C4\u5219`,
    priceSettingDes1: `\u4FDD\u6301\u539F\u4EF7`,
    addByAmount: `\u6309\u91D1\u989D\u589E\u52A0`,
    addByPercent: `\u6309\u767E\u5206\u6BD4\u589E\u52A0`,
    reduceByAmount: `\u6309\u91D1\u989D\u51CF\u5C11`,
    reduceByPercent: `\u6309\u767E\u5206\u51CF\u5C11`,
    noChange: `\u65E0\u53D8\u5316`,
    cancel: `\u53D6\u6D88`,
    confirm: `\u786E\u8BA4`,
    amount: `\u6570\u91CF`,
    scrapeList: `\u91C7\u96C6\u5217\u8868`,
    scrapeProducts: `\u91C7\u96C6\u5546\u54C1`,
    copyToChannel: `\u7EE7\u7EED\u514B\u9686\u5230\u6E20\u9053`,
    editPublish: `\u7F16\u8F91\u5E76\u53D1\u5E03`,
    productScraping: `\u5546\u54C1\u91C7\u96C6`,
    categoryScraping: `\u7C7B\u76EE\u91C7\u96C6`,
    storeScraping: `\u5E97\u94FA\u91C7\u96C6`,
    enterTip1: `\u8BF7\u586B\u5199\u5546\u54C1\u7F51\u5740\uFF0C\u591A\u4E2A\u7F51\u5740\u8BF7\u7528Enter\u6362\u884C\uFF0CMax.1000`,
    enterTip2: `\u8BF7\u586B\u5199\u5E97\u94FA\u5185\u7684\u5206\u7C7B\u7F51\u5740\uFF0C\u591A\u4E2A\u7F51\u5740\u8BF7\u7528Enter\u6362\u884C\uFF0CMax.100`,
    enterTip3: `\u8BF7\u586B\u5199 Shopee \u5E97\u94FA\u94FE\u63A5\u5730\u5740\uFF0C\u591A\u4E2A\u7F51\u5740\u8BF7\u7528Enter\u6362\u884C\uFF0CMax.100`,
    supportChannelsTip: `\u652F\u6301\u6E20\u9053\uFF1A`,
    collectSettings: `\u8BA4\u9886\u8BBE\u7F6E`,
    scraping: `\u91C7\u96C6`,
    allScrapingSuccess: `\u5168\u90E8\u91C7\u96C6\u6210\u529F`,
    allScrapingFailed: `\u5168\u90E8\u91C7\u96C6\u5931\u8D25`,
    someScrapingFailed: `\u90E8\u5206\u91C7\u96C6\u5931\u8D25`,
    totalNumber: `\u94FE\u63A5\u603B\u6570`,
    successNumber: `\u6210\u529F\u6570\u91CF`,
    failedNumber: `\u5931\u8D25\u6570\u91CF`,
    failedUrl: `\u5931\u8D25\u94FE\u63A5`,
    validNumber: `\u6709\u6548\u94FE\u63A5`,
    invalidNumber: `\u65E0\u6548\u94FE\u63A5`,
    scrapingFailed: `\u5546\u54C1\u91C7\u96C6\u5931\u8D25`,
    productName: `\u5546\u54C1\u540D\u79F0`,
    sku: `SKU`,
    productUrl: `\u5546\u54C1URL`,
    creator: `\u521B\u5EFA\u4EBA`,
    pleaseEnterContent: `\u8BF7\u8F93\u5165\u5185\u5BB9`,
    dataSources: `\u6570\u636E\u6765\u6E90`,
    createTime: `\u521B\u5EFA\u65F6\u95F4`,
    today: `\u4ECA\u5929`,
    weekly: `\u8FD11\u5468`,
    monthly: `\u8FD11\u4E2A\u6708`,
    yearly: `\u8FD11\u5E74`,
    reset: `\u91CD\u7F6E`,
    all: `\u5168\u90E8`,
    notCollected: `\u672A\u8BA4\u9886`,
    collected: `\u5DF2\u8BA4\u9886`,
    price: `\u4EF7\u683C`,
    noData: `\u6682\u65E0\u6570\u636E`,
    xDataSelected: `X\u6570\u636E\u9009\u4E2D`,
    collect: `\u8BA4\u9886`,
    delete: `\u5220\u9664`,
    operationGuide: `\u64CD\u4F5C\u6307\u5BFC`,
    deleteTip1: `\u786E\u8BA4\u5220\u9664\u91C7\u96C6\u5217\u8868\u4E2D\u5DF2\u9009\u4E2D\u7684\u5546\u54C1\uFF1F`,
    deleteTip2: `\u5DF2\u9009\u4E2D\u7684\u5546\u54C1\u4E0D\u4F1A\u5728\u6E20\u9053\u540C\u6B65\u5220\u9664\uFF0C\u8BF7\u81EA\u884C\u5220\u9664`,
    ScrapingInProcess: `\u91C7\u96C6\u4E2D\uFF0C\u8BF7\u7A0D\u7B49`,
    ClickTip: `\u70B9\u51FB\u8868\u683C\u4E2D\u7684\u5185\u5BB9\uFF0C\u53EF\u8FDB\u884C\u7F16\u8F91\u64CD\u4F5C\uFF01`,
    productNameImage: `\u5546\u54C1\u540D\u79F0&\u56FE\u7247`,
    variantName: `\u89C4\u683C\u540D\u79F0`,
    masterSKU: `\u4E3BSKU`,
    availableStock: `\u53EF\u7528\u5E93\u5B58`,
    defaultPrice: `\u9ED8\u8BA4\u552E\u4EF7`,
    unitPurchasePrice: `\u91C7\u8D2D\u5355\u4EF7`,
    action: `\u64CD\u4F5C`,
    discardChangeTip: `\u4F60\u786E\u5B9A\u8981\u653E\u5F03\u8FD9\u6B21\u66F4\u65B0\u5417\uFF1F`,
    viewNow: `\u9A6C\u4E0A\u67E5\u770B`,
    scrapeManagement: `\u91C7\u96C6\u7BA1\u7406`,
    mskuExistsTip: `\u4E3BSKU\u5DF2\u5B58\u5728\uFF0C\u8BF7\u91CD\u65B0\u547D\u540D`,
    collectedResultTip: `3\u4E2A\u5546\u54C1 \u5DF2\u8BA4\u9886\u5230\u4E3B\u5546\u54C1`,
    deletedResultTip1: `\u6210\u529F\u5220\u9664`,
    deletedResultTip2: `65\u6761\u6570\u636E\u5DF2\u5220\u9664`,
    ScrapingInProcessDec: `\u6B63\u5728\u91C7\u96C6\u5E97\u94FA\u5546\u54C1\uFF0C\u6BCF\u4E2A\u5E97\u94FA\u9884\u4F30\u8981\u82B110\u5206\u949F\u3002\u60A8\u53EF\u4EE5\u7EE7\u7EED\u91C7\u96C6\u5176\u4ED6\u5E97\u94FA\u6216\u8005\u524D\u5F80\u91C7\u96C6\u5217\u8868\u67E5\u770B\u5DF2\u91C7\u96C6\u7684\u5546\u54C1\u3002`,
    continueToScrape: `\u7EE7\u7EED\u91C7\u96C6`,
    collectToMasterProduct: `\u8BA4\u9886\u5230\u4E3B\u5546\u54C1`,
    collectToMasterProductDec: `\u8BA4\u9886\u5230\u4E3B\u5546\u54C1\u540E\u518D\u53D1\u5E03\u5230\u6E20\u9053\u5E97\u94FA\uFF0C\u4EE5\u4FBF\u7EDF\u4E00\u7BA1\u7406\u4EF7\u683C\u548C\u5E93\u5B58`,
    autoCollectToMp: `\u81EA\u52A8\u8BA4\u9886\u5230\u4E3B\u5546\u54C1`,
    selectProducts: `\u9009\u62E9\u5546\u54C1\u5E76\u6279\u91CF\u8BA4\u9886`,
    autoCollectToMpLimit: `\u91C7\u96C6\u5546\u54C1\u7684\u5E93\u5B58\u4E3A0\u65F6\uFF0C\u4E0D\u652F\u6301\u81EA\u52A8\u8BA4\u9886`,
    inventorySkuLimit: `\u4E3BSKU\u6700\u591A50\u4E2A\u5B57\u7B26`,
    iskuCannotBeEmpty: `\u4E3BSKU\u4E0D\u80FD\u4E3A\u7A7A\uFF01`,
    purchasePriceLimit: `\u91D1\u989D\u5FC5\u987B\u57280 \u301C 1,000,000,000\u4E4B\u95F4\uFF01`,
    addAvailableStockLimit: `\u53EF\u7528\u5E93\u5B58\u8303\u56F4\u662F0-999,999`,
    productNameLimit: `\u5546\u54C1\u540D\u79F0\u5FC5\u987B\u662F1\u5230300\u4E2A\u5B57\u7B26`,
    findSource: `\u627E\u8D27\u6E90`,
    editDec: `\u5728\u5E97\u94FA\u7684\u5546\u54C1\u8349\u7A3F\u7BB1\u8FDB\u884C\u7F16\u8F91\u548C\u53D1\u5E03`,
    scrapeProduct: `\u91C7\u96C6\u5546\u54C1`,
    inputLinkTip: `\u8F93\u5165\u94FE\u63A5\u6765\u91C7\u96C6\u5546\u54C1`,
    collectToMasterDec: `\u6279\u91CF\u8BA4\u9886\u5E76\u521B\u5EFA\u4E3B\u5546\u54C1`,
    copyToStoreTip2: `\u514B\u9686\u5230\u5E97\u94FA\u552E\u5356`,
    copyToStoreTip3: `\u9009\u62E9\u5E97\u94FA\u5E76\u5C06\u4E3B\u5546\u54C1\u514B\u9686\u5230\u5E97\u94FA\u8349\u7A3F\u7BB1`,
    close: `\u5173\u95ED`,
    allLinksInvalid: `\u5168\u90E8\u94FE\u63A5\u65E0\u6548\uFF0C\u8BF7\u68C0\u67E5`,
    someLinksInvalid: `\u90E8\u5206\u94FE\u63A5\u65E0\u6548\uFF0C\u8BF7\u68C0\u67E5`,
    viewMore: `\u5C55\u5F00`,
    viewLess: `\u6536\u8D77`,
    faqName: `\u4E3B\u5546\u54C1\u5982\u4F55\u514B\u9686\u5230\u6E20\u9053\u5E97\u94FA`,
    faqName1: `\u5982\u4F55\u91C7\u96C6Shopee\u6E20\u9053\u7684\u5546\u54C1`,
    recommendToUseTheScrapePlugin: `\u5EFA\u8BAE\u4F7F\u7528\u91C7\u96C6\u63D2\u4EF6\uFF0C\u529F\u80FD\u66F4\u7A33\u5B9A\u66F4\u5FEB\u901F\uFF01`,
    recommendToUseTheScrapePluginTip1: `1\u3001\u63A8\u8350\u6D4F\u89C8\u5668\uFF1AGoogle Chrome!`,
    recommendToUseTheScrapePluginTip2: `2\u3001\u63D2\u4EF6\u5B89\u88C5\u5730\u5740\uFF1A`,
    recommendToUseTheScrapePluginTip2Sub: `\u524D\u5F80\u8C37\u6B4C\u5546\u5E97\u5B89\u88C5`,
    recommendToUseTheScrapePluginTip3: `3\u3001\u65E0\u6CD5\u8BBF\u95EE\u8C37\u6B4C\u5546\u5E97\u65F6\uFF0C\u5728\u6B64\u4E0B\u8F7D\u63D2\u4EF6\uFF1A`,
    recommendToUseTheScrapePluginTip3Sub: `\u4E0B\u8F7D\u5E76\u5B89\u88C5\u63D2\u4EF6`,
    recommendToUseTheScrapePluginTip4: `4\u3001\u5173\u4E8E\u5982\u4F55\u4F7F\u7528\u63D2\u4EF6\uFF0C\u8BF7\u53C2\u8003\uFF1A`,
    recommendToUseTheScrapePluginTip4Sub: `\u4F7F\u7528\u6559\u7A0B`,
    pluginScraping: `\u91C7\u96C6\u63D2\u4EF6`,
    scrapeSuccess: `\u91C7\u96C6\u6210\u529F`,
    scrapeFailedPleaseCheckLinkOr: `\u91C7\u96C6\u5931\u8D25\uFF0C\u8BF7\u68C0\u67E5\u94FE\u63A5\u6216\u7A0D\u540E\u91CD\u8BD5`,
    installTheTutorial: `\u5B89\u88C5\u6559\u7A0B`
  },
  id: {
    changePriceTo: `Edit harga jadi`,
    successfullyCollected: `Berhasil Collect`,
    result: `Hasil`,
    mustEnterAtLeastOneAt: `Anda harus memasukkan setidaknya satu di awal atau akhir`,
    editMasterSkuMass: `Edit master SKU secara massal`,
    atTheBeginningAdd: `Tambahkan di awal`,
    increaseStartingValueAutomatically: `Secara otomatis meningkatkan nilai awal`,
    atTheEndAdd: `Tambahkan di akhir`,
    preview: `Preview`,
    xxWithYyyReplace: `Ganti xx dengan yyy`,
    rangeIsThe: `Rentangnya adalah 0-999,999`,
    draft: `Draft`,
    editUnitPurchasePriceMass: `Edit massal harga beli satuan`,
    editDefaultPriceMass: `Edit massal harga default`,
    editAvailableStockMass: `Edit massal stok tersedia`,
    massEdit: `Edit Massal`,
    percentageLimit: `Kisaran persentase harus 0-100,000`,
    PriceLimit: `Harga Beli Harus diantara 0-1,000,000,000`,
    time: `Waktu`,
    category: `Kategori`,
    updateTime: `Waktu Pembaruan`,
    search: `Cari`,
    clear: `Kosongkan`,
    filter: `Filter`,
    keyword: `keyword`,
    scrapingSettings: `Pengaturan Scrape`,
    scrapingSettingsTip: `Setelah atur Collect Otomatis ke Daftar Produk Utama, Produk yang berhasil di Scrape akan secara otomatis diimpor ke Daftar Produk Utama, dan diset ke harga jual berdasarkan Pengaturan Harga`,
    priceSetting: `Pengaturan Harga`,
    priceSettingTip: `Peraturan Harga berdasarkan Harga asli`,
    priceSettingDes1: `Sama dengan Harga Asli`,
    addByAmount: `Tambah berdasarkan jumlah`,
    addByPercent: `Tambah berdasarkan presentase`,
    reduceByAmount: `Kurangi berdasarkan jumlah`,
    reduceByPercent: `Kurangi berdasarkan presentase`,
    noChange: `Tidak ada perubahan`,
    cancel: `Batalkan`,
    confirm: `Konfirmasi`,
    amount: `Nilai`,
    scrapeList: `Daftar Scrape`,
    scrapeProducts: `Scrape Produk`,
    copyToChannel: `Lanjutkan Salin ke Channel`,
    editPublish: `Edit dan Tampilkan`,
    productScraping: `Scrape Produk`,
    categoryScraping: `Scrape Kategori`,
    storeScraping: `Scrape Toko`,
    enterTip1: `Silakan isi URL Produk, Gunakan Enter untuk gabungkan beberapa URL,Max.1000`,
    enterTip2: `Silakan isi situs web Toko. Jika Anda ingin memasukkan beberapa situs web, Gunakan Enter untuk gabungkan. Max.100`,
    enterTip3: `Silakan isi link URL Toko Shopee. Untuk memasukkan beberapa Link sekaligus, silakan gunakan Enter untuk memisahkan. Max.100`,
    supportChannelsTip: `Channel yang didukung: `,
    collectSettings: `Pengaturan Collect`,
    scraping: `Scrape`,
    allScrapingSuccess: `Scrape Berhasil Semua`,
    allScrapingFailed: `Scrape Gagal Semua`,
    someScrapingFailed: `Scrape Gagal Sebagian`,
    totalNumber: `Jumlah Total`,
    successNumber: `Jumlah Berhasil`,
    failedNumber: `Jumlah Gagal`,
    failedUrl: `URL Gagal`,
    validNumber: `Tautan yang valid`,
    invalidNumber: `Tautan Tidak Valid`,
    scrapingFailed: `Gagal Scrape Produk`,
    productName: `Nama Produk`,
    sku: `SKU`,
    productUrl: `URL Produk`,
    creator: `Pembuat`,
    pleaseEnterContent: `Silakan Masukkan Konten`,
    dataSources: `Sumber Data`,
    createTime: `Waktu Pembuatan`,
    today: `Hari Ini`,
    weekly: `Mingguan`,
    monthly: `Bulanan`,
    yearly: `Tahunan`,
    reset: `Atur Ulang`,
    all: `Semua`,
    notCollected: `Tidak Di Collect`,
    collected: `Telah Di Collect`,
    price: `Harga`,
    noData: `Tidak Ada Data`,
    xDataSelected: `X Data Dipilih`,
    collect: `Collect`,
    delete: `Hapus`,
    operationGuide: `Panduan Operasi`,
    deleteTip1: `Konfirmasi untuk menghapus Produk yang dipilih dalam Daftar Scrape?`,
    deleteTip2: `Produk yang dipilih tidak dapat dihapus di Channel, Harap hapus sendiri`,
    ScrapingInProcess: `Dalam proses Scraping, Mohon tunggu.`,
    ClickTip: `Klik pada informasi di tabel untuk mengedit.`,
    productNameImage: `Nama Produk&Gambar`,
    variantName: `Nama Varian`,
    masterSKU: `Master SKU`,
    availableStock: `Stok Tersedia`,
    defaultPrice: `Harga Default`,
    unitPurchasePrice: `Harga Beli Satuan`,
    action: `Atur`,
    discardChangeTip: `Yakin ingin membatalkan perubahan ini?`,
    viewNow: `Lihat sekarang`,
    scrapeManagement: `Manajemen Scrape`,
    mskuExistsTip: `Master SKU sudah ada, harap ganti nama`,
    collectedResultTip: `3 produk telah dicollect ke Master Produk`,
    deletedResultTip1: `Berhasil dihapus`,
    deletedResultTip2: `65 data telah dihapus`,
    ScrapingInProcessDec: `Produk toko sedang discrape, setiap toko akan memakan waktu sekitar 10 menit. Anda dapat lanjut scrape toko lain atau cek Daftar Collect untuk melihat produk yang telah dicollect`,
    continueToScrape: `Lanjutkan Scrape`,
    collectToMasterProduct: `Collect ke Master Produk`,
    collectToMasterProductDec: `Setelah collect Master Produk, tampilkan ke toko channel sehingga Anda dapat mulai mengelola harga dan stok`,
    autoCollectToMp: `Collect Otomatis ke produk Master`,
    selectProducts: `Pilih Produk dan Collect massal`,
    autoCollectToMpLimit: `Jika stok produk yang di scrape 0, maka tidak bisa collect otomatis`,
    inventorySkuLimit: `Master SKU harus dibawah 50 karakter`,
    iskuCannotBeEmpty: `Master SKU wajib diisi!`,
    purchasePriceLimit: `Harga Beli Harus diantara 0-1,000,000,000`,
    addAvailableStockLimit: `Stok Tersedia harus diantara 0-999,999`,
    productNameLimit: `Nama Produk harus diantara 1-300 Karakter`,
    findSource: `Temukan Supplier`,
    editDec: `Edit dan Tampilkan dari Draf di Toko`,
    scrapeProduct: `Scrape Produk`,
    inputLinkTip: `Masukkan link untuk Scrape Produk`,
    collectToMasterDec: `Collect dan buat Master Produk secara massal`,
    copyToStoreTip2: `Salin ke Toko untuk dijual`,
    copyToStoreTip3: `Pilih Toko dan salin Master Produk sebagai draf di Toko`,
    close: `Tutup`,
    allLinksInvalid: `Semua link invalid, silahkan cek`,
    someLinksInvalid: `Beberapa link invalid, silahkan cek`,
    viewMore: `Lihat lebih banyak`,
    viewLess: `Lihat lebih sedikit`,
    faqName: `Cara mengkloning produk Master ke penyimpanan saluran`,
    faqName1: `Bagaimana cara mengumpulkan produk dari saluran Shopee?`,
    recommendToUseTheScrapePlugin: `Kami merekomendasikan untuk menggunakan ekstensi scraper, fitur ini lebih stabil dan lebih cepat!`,
    recommendToUseTheScrapePluginTip1: `1. Browser yang disarankan: Google Chrome!`,
    recommendToUseTheScrapePluginTip2: `2. Link instalasi ekstensi:`,
    recommendToUseTheScrapePluginTip2Sub: `Ke google web store untuk instal`,
    recommendToUseTheScrapePluginTip3: `3. Jika Anda tidak dapat mengakses Google Store, unduh ekstensi di sini:`,
    recommendToUseTheScrapePluginTip3Sub: `Unduh dan Instal ekstensi`,
    recommendToUseTheScrapePluginTip4: `4. Untuk cara menggunakan ekstensi, silakan lihat:`,
    recommendToUseTheScrapePluginTip4Sub: `Panduan Operasi`,
    pluginScraping: `Ekstensi Scrape`,
    scrapeSuccess: `Scrape Berhasil`,
    scrapeFailedPleaseCheckLinkOr: `Scrape Gagal, periksa kembali tautan atau coba lagi nanti`,
    installTheTutorial: `Tutorial Instal`
  },
  th: {
    changePriceTo: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E40\u0E1B\u0E47\u0E19`,
    successfullyCollected: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    result: `\u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C`,
    mustEnterAtLeastOneAt: `\u0E04\u0E38\u0E13\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E19\u0E49\u0E2D\u0E22\u0E2B\u0E19\u0E36\u0E48\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E43\u0E19\u0E15\u0E2D\u0E19\u0E15\u0E49\u0E19\u0E2B\u0E23\u0E37\u0E2D\u0E15\u0E2D\u0E19\u0E17\u0E49\u0E32\u0E22`,
    editMasterSkuMass: `\u0E41\u0E01\u0E49\u0E44\u0E02 SKU\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    atTheBeginningAdd: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E19\u0E15\u0E2D\u0E19\u0E15\u0E49\u0E19`,
    increaseStartingValueAutomatically: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E21\u0E39\u0E25\u0E04\u0E48\u0E32\u0E17\u0E35\u0E48\u0E40\u0E23\u0E34\u0E48\u0E21\u0E15\u0E49\u0E19\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    atTheEndAdd: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E43\u0E19\u0E15\u0E2D\u0E19\u0E17\u0E49\u0E32\u0E22`,
    preview: `\u0E14\u0E39\u0E15\u0E31\u0E27\u0E2D\u0E22\u0E48\u0E32\u0E07`,
    xxWithYyyReplace: `\u0E41\u0E17\u0E19\u0E17\u0E35\u0E48 xx \u0E14\u0E49\u0E27\u0E22 yyy`,
    rangeIsThe: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E04\u0E37\u0E2D0-999,999`,
    draft: `\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07`,
    editUnitPurchasePriceMass: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    editDefaultPriceMass: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E23\u0E32\u0E04\u0E32\u0E15\u0E31\u0E49\u0E07\u0E15\u0E49\u0E19\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    editAvailableStockMass: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E1E\u0E23\u0E49\u0E2D\u0E07\u0E43\u0E0A\u0E49\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    massEdit: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    percentageLimit: `\u0E02\u0E2D\u0E1A\u0E40\u0E02\u0E15\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E48\u0E39\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 0-100,000`,
    PriceLimit: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 0 \u301C 1,000,000,000`,
    time: `\u0E40\u0E27\u0E25\u0E32`,
    category: `\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48`,
    updateTime: `\u0E40\u0E27\u0E25\u0E32\u0E2D\u0E31\u0E1B\u0E40\u0E14\u0E15`,
    search: `\u0E04\u0E49\u0E19\u0E2B\u0E32`,
    clear: `\u0E25\u0E1A`,
    filter: `\u0E1F\u0E34\u0E25\u0E40\u0E15\u0E2D\u0E23\u0E4C`,
    keyword: `\u0E04\u0E35\u0E22\u0E4C\u0E40\u0E27\u0E34\u0E23\u0E4C\u0E14`,
    scrapingSettings: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    scrapingSettingsTip: `\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E23\u0E27\u0E1A\u0E23\u0E27\u0E21\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E41\u0E25\u0E49\u0E27 \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08\u0E08\u0E30\u0E16\u0E39\u0E01\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34 \u0E41\u0E25\u0E30\u0E19\u0E33\u0E40\u0E02\u0E49\u0E32\u0E2A\u0E39\u0E48\u0E23\u0E32\u0E04\u0E32\u0E02\u0E32\u0E22\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34\u0E15\u0E32\u0E21\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E23\u0E32\u0E04\u0E32`,
    priceSetting: `\u0E01\u0E32\u0E23\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E23\u0E32\u0E04\u0E32`,
    priceSettingTip: `\u0E40\u0E07\u0E37\u0E48\u0E2D\u0E19\u0E44\u0E02\u0E01\u0E32\u0E23\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E23\u0E32\u0E04\u0E32\u0E2D\u0E34\u0E07\u0E08\u0E32\u0E01\u0E23\u0E32\u0E04\u0E32\u0E40\u0E14\u0E34\u0E21`,
    priceSettingDes1: `\u0E43\u0E0A\u0E49\u0E23\u0E32\u0E04\u0E32\u0E40\u0E14\u0E34\u0E21`,
    addByAmount: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E32\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19`,
    addByPercent: `\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E15\u0E32\u0E21\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C`,
    reduceByAmount: `\u0E25\u0E14\u0E15\u0E32\u0E21\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19`,
    reduceByPercent: `\u0E25\u0E14\u0E15\u0E32\u0E21\u0E40\u0E1B\u0E2D\u0E23\u0E4C\u0E40\u0E0B\u0E47\u0E19\u0E15\u0E4C`,
    noChange: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07`,
    cancel: `\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01`,
    confirm: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19`,
    amount: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19`,
    scrapeList: `\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    scrapeProducts: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    copyToChannel: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    editPublish: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48`,
    productScraping: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    categoryScraping: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2B\u0E21\u0E27\u0E14\u0E2B\u0E21\u0E39\u0E48`,
    storeScraping: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    enterTip1: `\u0E42\u0E1B\u0E23\u0E14\u0E01\u0E23\u0E2D\u0E01 URL \u0E02\u0E2D\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A URL \u0E2B\u0E25\u0E32\u0E22\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49 Enter \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E1A\u0E23\u0E23\u0E17\u0E31\u0E14 \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E141000 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23`,
    enterTip2: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C\u0E02\u0E2D\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 \u0E2B\u0E32\u0E01\u0E21\u0E35\u0E40\u0E27\u0E47\u0E1A\u0E44\u0E0B\u0E15\u0E4C \u0E2B\u0E25\u0E32\u0E22\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49 Enter \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E1A\u0E23\u0E23\u0E17\u0E31\u0E14 \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E14 100 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23`,
    enterTip3: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 Shopee \u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A URL \u0E2B\u0E25\u0E32\u0E22\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23 \u0E42\u0E1B\u0E23\u0E14\u0E43\u0E0A\u0E49 Enter \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E1A\u0E23\u0E23\u0E17\u0E31\u0E14 \u0E2A\u0E39\u0E07\u0E2A\u0E38\u0E141000 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23`,
    supportChannelsTip: `\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A: `,
    collectSettings: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    scraping: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`,
    allScrapingSuccess: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    allScrapingFailed: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    someScrapingFailed: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    totalNumber: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    successNumber: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    failedNumber: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E17\u0E35\u0E48\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    failedUrl: `URL \u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    validNumber: `\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E17\u0E35\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07`,
    invalidNumber: `\u0E25\u0E34\u0E07\u0E01\u0E4C\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07`,
    scrapingFailed: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27`,
    productName: `\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    sku: `SKU`,
    productUrl: `SKU \u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    creator: `\u0E1C\u0E39\u0E49\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    pleaseEnterContent: `\u0E01\u0E23\u0E38\u0E13\u0E32\u0E01\u0E23\u0E2D\u0E01\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32`,
    dataSources: `\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E17\u0E35\u0E48\u0E21\u0E32\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`,
    createTime: `\u0E40\u0E27\u0E25\u0E32\u0E2A\u0E23\u0E49\u0E32\u0E07`,
    today: `\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49`,
    weekly: `\u0E23\u0E32\u0E22\u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C`,
    monthly: `\u0E23\u0E32\u0E22\u0E40\u0E14\u0E37\u0E2D\u0E19`,
    yearly: `\u0E23\u0E32\u0E22\u0E1B\u0E35`,
    reset: `\u0E15\u0E31\u0E49\u0E07\u0E04\u0E48\u0E32\u0E43\u0E2B\u0E21\u0E48`,
    all: `\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14`,
    notCollected: `\u0E22\u0E31\u0E07\u0E44\u0E21\u0E48\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    collected: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E49\u0E27`,
    price: `\u0E23\u0E32\u0E04\u0E32`,
    noData: `\u0E44\u0E21\u0E48\u0E21\u0E35\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25`,
    xDataSelected: `X \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01`,
    collect: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    delete: `\u0E25\u0E1A`,
    operationGuide: `\u0E04\u0E39\u0E48\u0E21\u0E37\u0E2D\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19`,
    deleteTip1: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E30\u0E25\u0E1A\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E43\u0E19\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01?`,
    deleteTip2: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E08\u0E30\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E43\u0E19\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32 \u0E42\u0E1B\u0E23\u0E14\u0E25\u0E1A\u0E40\u0E2D\u0E07`,
    ScrapingInProcess: `\u0E01\u0E33\u0E25\u0E31\u0E07\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E23\u0E2D\u0E2A\u0E31\u0E01\u0E04\u0E23\u0E39\u0E48`,
    ClickTip: `\u0E04\u0E25\u0E34\u0E01\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E15\u0E32\u0E23\u0E32\u0E07\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E41\u0E01\u0E49\u0E44\u0E02`,
    productNameImage: `\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32&\u0E23\u0E39\u0E1B\u0E20\u0E32\u0E1E`,
    variantName: `\u0E0A\u0E37\u0E48\u0E2D\u0E15\u0E31\u0E27\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    masterSKU: `SKU \u0E2B\u0E25\u0E31\u0E01`,
    availableStock: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E2A\u0E48\u0E07`,
    defaultPrice: `\u0E23\u0E32\u0E04\u0E32\u0E15\u0E31\u0E49\u0E07\u0E15\u0E49\u0E19`,
    unitPurchasePrice: `\u0E23\u0E32\u0E04\u0E32\u0E0B\u0E37\u0E49\u0E2D\u0E15\u0E48\u0E2D\u0E2B\u0E19\u0E48\u0E27\u0E22`,
    action: `\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E01\u0E32\u0E23`,
    discardChangeTip: `\u0E22\u0E37\u0E19\u0E22\u0E31\u0E19\u0E08\u0E30\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E22\u0E01\u0E40\u0E25\u0E34\u0E01\u0E01\u0E32\u0E23\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E19\u0E35\u0E49\uFF1F`,
    viewNow: `\u0E14\u0E39\u0E17\u0E31\u0E19\u0E17\u0E35`,
    scrapeManagement: `\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    mskuExistsTip: `\u0E21\u0E35SKU\u0E2B\u0E25\u0E35\u0E01\u0E19\u0E35\u0E49\u0E2D\u0E22\u0E39\u0E48\u0E41\u0E25\u0E49\u0E27 \u0E42\u0E1B\u0E23\u0E14\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E0A\u0E37\u0E48\u0E2D`,
    collectedResultTip: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 3 \u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E44\u0E14\u0E49\u0E16\u0E39\u0E01\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E40\u0E21\u0E19\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E41\u0E25\u0E49\u0E27`,
    deletedResultTip1: `\u0E25\u0E1A\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    deletedResultTip2: `65 \u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E16\u0E39\u0E01\u0E25\u0E1A\u0E41\u0E25\u0E49\u0E27`,
    ScrapingInProcessDec: `\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E1A\u0E19\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E01\u0E33\u0E25\u0E31\u0E07\u0E16\u0E39\u0E01\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01 \u0E41\u0E25\u0E30\u0E41\u0E15\u0E48\u0E25\u0E30\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E08\u0E30\u0E43\u0E0A\u0E49\u0E40\u0E27\u0E25\u0E32\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 10 \u0E19\u0E32\u0E17\u0E35 \u0E04\u0E38\u0E13\u0E22\u0E31\u0E07\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E2D\u0E37\u0E48\u0E19 \u0E46 \u0E2B\u0E23\u0E37\u0E2D\u0E44\u0E1B\u0E17\u0E35\u0E48\u0E23\u0E32\u0E22\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E14\u0E39\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E14\u0E49`,
    continueToScrape: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E15\u0E48\u0E2D\u0E44\u0E1B`,
    collectToMasterProduct: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01`,
    collectToMasterProductDec: `\u0E2B\u0E25\u0E31\u0E07\u0E08\u0E32\u0E01\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E41\u0E25\u0E49\u0E27 \u0E43\u0E2B\u0E49\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E23\u0E34\u0E48\u0E21\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23\u0E23\u0E32\u0E04\u0E32\u0E41\u0E25\u0E30\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E44\u0E14\u0E49`,
    autoCollectToMp: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E42\u0E14\u0E22\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    selectProducts: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E41\u0E25\u0E30\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    autoCollectToMpLimit: `\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E17\u0E35\u0E48\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E21\u0E32\u0E40\u0E1B\u0E47\u0E19 0 \u0E23\u0E30\u0E1A\u0E1A\u0E08\u0E30\u0E44\u0E21\u0E48\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2D\u0E31\u0E15\u0E42\u0E19\u0E21\u0E31\u0E15\u0E34`,
    inventorySkuLimit: `SKU \u0E2B\u0E25\u0E31\u0E01\u0E04\u0E27\u0E23\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 300 \u0E2D\u0E31\u0E01\u0E29\u0E23`,
    iskuCannotBeEmpty: `\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E23\u0E2D\u0E01 SKU \u0E2B\u0E25\u0E31\u0E01`,
    purchasePriceLimit: `\u0E08\u0E33\u0E19\u0E27\u0E19\u0E40\u0E07\u0E34\u0E19\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E070-1,000,000,000`,
    addAvailableStockLimit: `\u0E2A\u0E15\u0E47\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E04\u0E27\u0E23\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 0-999,99`,
    productNameLimit: `\u0E0A\u0E37\u0E48\u0E2D\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E15\u0E49\u0E2D\u0E07\u0E2D\u0E22\u0E39\u0E48\u0E23\u0E30\u0E2B\u0E27\u0E48\u0E32\u0E07 1-300 \u0E2D\u0E31\u0E01\u0E29\u0E23`,
    findSource: `\u0E2B\u0E32\u0E41\u0E2B\u0E25\u0E48\u0E07\u0E17\u0E35\u0E48\u0E21\u0E32\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    editDec: `\u0E41\u0E01\u0E49\u0E44\u0E02\u0E41\u0E25\u0E30\u0E40\u0E1C\u0E22\u0E41\u0E1E\u0E23\u0E48\u0E08\u0E32\u0E01\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    scrapeProduct: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    inputLinkTip: `\u0E01\u0E23\u0E2D\u0E01\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32`,
    collectToMasterDec: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E41\u0E25\u0E30\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E40\u0E1B\u0E47\u0E19\u0E01\u0E25\u0E38\u0E48\u0E21`,
    copyToStoreTip2: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E02\u0E32\u0E22`,
    copyToStoreTip3: `\u0E40\u0E25\u0E37\u0E2D\u0E01\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E41\u0E25\u0E30\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E40\u0E1B\u0E47\u0E19\u0E09\u0E1A\u0E31\u0E1A\u0E23\u0E48\u0E32\u0E07\u0E43\u0E19\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32`,
    close: `\u0E1B\u0E34\u0E14`,
    allLinksInvalid: `\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E17\u0E31\u0E49\u0E07\u0E2B\u0E21\u0E14\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A`,
    someLinksInvalid: `\u0E25\u0E34\u0E07\u0E04\u0E4C\u0E1A\u0E32\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E44\u0E21\u0E48\u0E16\u0E39\u0E01\u0E15\u0E49\u0E2D\u0E07 \u0E42\u0E1B\u0E23\u0E14\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A`,
    viewMore: `\u0E14\u0E38\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E40\u0E14\u0E34\u0E21`,
    viewLess: `\u0E22\u0E48\u0E2D\u0E40\u0E19\u0E37\u0E49\u0E2D\u0E2B\u0E32`,
    faqName: `\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E2B\u0E25\u0E31\u0E01\u0E44\u0E1B\u0E22\u0E31\u0E07\u0E23\u0E49\u0E32\u0E19\u0E04\u0E49\u0E32\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07`,
    faqName1: `\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32\u0E08\u0E32\u0E01\u0E0A\u0E48\u0E2D\u0E07\u0E17\u0E32\u0E07 Shopee`,
    recommendToUseTheScrapePlugin: `\u0E02\u0E2D\u0E41\u0E19\u0E30\u0E19\u0E33\u0E1F\u0E35\u0E40\u0E08\u0E2D\u0E23\u0E4C\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E34\u0E19\u0E04\u0E49\u0E32 \u0E40\u0E2A\u0E16\u0E35\u0E22\u0E23\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19\u0E41\u0E25\u0E30\u0E40\u0E23\u0E47\u0E27\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19`,
    recommendToUseTheScrapePluginTip1: `1. \u0E40\u0E1A\u0E23\u0E32\u0E27\u0E4C\u0E40\u0E0B\u0E2D\u0E23\u0E4C\u0E41\u0E19\u0E30\u0E19\u0E33 : Google Chrome`,
    recommendToUseTheScrapePluginTip2: `2. \u0E17\u0E35\u0E48\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E01\u0E32\u0E23\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22:`,
    recommendToUseTheScrapePluginTip2Sub: `\u0E44\u0E1B\u0E17\u0E35\u0E48 Google Store \u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07`,
    recommendToUseTheScrapePluginTip3: `3. \u0E2B\u0E32\u0E01\u0E44\u0E21\u0E48\u0E2A\u0E32\u0E21\u0E32\u0E23\u0E16\u0E40\u0E02\u0E49\u0E32 Google Store \u0E44\u0E14\u0E49 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E17\u0E35\u0E48\u0E19\u0E35\u0E48:`,
    recommendToUseTheScrapePluginTip3Sub: `\u0E14\u0E32\u0E27\u0E19\u0E4C\u0E42\u0E2B\u0E25\u0E14\u0E41\u0E25\u0E30\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22`,
    recommendToUseTheScrapePluginTip4: `4.\u0E27\u0E34\u0E18\u0E35\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E07\u0E32\u0E19\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22:`,
    recommendToUseTheScrapePluginTip4Sub: `\u0E01\u0E32\u0E23\u0E43\u0E0A\u0E49\u0E1A\u0E17\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E2D\u0E19`,
    pluginScraping: `\u0E2A\u0E48\u0E27\u0E19\u0E02\u0E22\u0E32\u0E22\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01`,
    scrapeSuccess: `\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E2A\u0E33\u0E40\u0E23\u0E47\u0E08`,
    scrapeFailedPleaseCheckLinkOr: `\u0E01\u0E32\u0E23\u0E04\u0E31\u0E14\u0E25\u0E2D\u0E01\u0E25\u0E49\u0E21\u0E40\u0E2B\u0E25\u0E27 \u0E01\u0E23\u0E38\u0E13\u0E32\u0E15\u0E23\u0E27\u0E08\u0E2A\u0E2D\u0E1A\u0E01\u0E32\u0E23\u0E40\u0E0A\u0E37\u0E48\u0E2D\u0E21\u0E15\u0E48\u0E2D\u0E2B\u0E23\u0E37\u0E2D\u0E25\u0E2D\u0E07\u0E2D\u0E35\u0E01\u0E04\u0E23\u0E31\u0E49\u0E07\u0E43\u0E19\u0E20\u0E32\u0E22\u0E2B\u0E25\u0E31\u0E07`,
    installTheTutorial: `\u0E15\u0E34\u0E14\u0E15\u0E31\u0E49\u0E07\u0E1A\u0E17\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E2D\u0E19`
  },
  vn: {
    changePriceTo: `Tr\u1EF1c ti\u1EBFp s\u1EEDa gi\xE1 th\xE0nh`,
    successfullyCollected: `Nh\u1EADn th\xE0nh c\xF4ng`,
    result: `K\u1EBFt qu\u1EA3`,
    mustEnterAtLeastOneAt: `B\u1EA1n b\u1EAFt bu\u1ED9c nh\u1EADp \xEDt nh\u1EA5t 1 ph\u1EA7n m\u1EDF \u0111\u1EA7u ho\u1EB7c k\u1EBFt th\xFAc`,
    editMasterSkuMass: `Ch\u1EC9nh s\u1EEDa nhi\u1EC1u SKU ch\xEDnh`,
    atTheBeginningAdd: `Th\xEAm m\u1EDF \u0111\u1EA7u`,
    increaseStartingValueAutomatically: `T\u1EF1 \u0111\u1ED9ng t\u1EA1o gi\xE1 tr\u1ECB b\u1EAFt \u0111\u1EA7u`,
    atTheEndAdd: `Th\xEAm k\u1EBFt th\xFAc`,
    preview: `Xem`,
    xxWithYyyReplace: `xx thay th\u1EBF th\xE0nh yyy`,
    rangeIsThe: `Ph\u1EA1m vi t\u1EEB 0-999.999`,
    draft: `B\u1EA3n nh\xE1p`,
    editUnitPurchasePriceMass: `Ch\u1EC9nh s\u1EEDa nhi\u1EC1u \u0111\u01A1n gi\xE1 mua h\xE0ng`,
    editDefaultPriceMass: `Ch\u1EC9nh s\u1EEDa gi\xE1 b\xE1n m\u1EB7c \u0111\u1ECBnh h\xE0ng lo\u1EA1t`,
    editAvailableStockMass: `Ch\u1EC9nh s\u1EEDa nhi\u1EC1u T\u1ED3n kho c\xF3 s\u1EB5n`,
    massEdit: `Ch\u1EC9nh s\u1EEDa h\xE0ng lo\u1EA1t`,
    percentageLimit: `Ph\u1EA1m vi ph\u1EA7n tr\u0103m ph\u1EA3i t\u1EEB 0-100.000`,
    PriceLimit: `S\u1ED1 ti\u1EC1n ph\u1EA3i t\u1EEB gi\u1EEFa 0-1000.000.000`,
    time: `Th\u1EDDi gian`,
    category: `Danh m\u1EE5c`,
    updateTime: `Th\u1EDDi gian c\u1EA1p nh\u1EA5t`,
    search: `T\xECm ki\u1EBFm`,
    clear: `\u0110\u1EB7t l\u1EA1i`,
    filter: `L\u1ECDc`,
    keyword: `T\u1EEB kh\xF3a`,
    scrapingSettings: `C\xE0i \u0111\u1EB7t s\u01B0u t\u1EADp`,
    scrapingSettingsTip: `Sau khi thi\u1EBFt l\u1EADp t\u1EF1 \u0111\u1ED9ng s\u01B0u t\u1EADp v\xE0o Danh s\xE1ch s\u1EA3n ph\u1EA9m ch\xEDnh, c\xE1c s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c thu th\u1EADp th\xE0nh c\xF4ng s\u1EBD t\u1EF1 \u0111\u1ED9ng s\u01B0u t\u1EADp v\xE0o Danh s\xE1ch s\u1EA3n ph\u1EA9m ch\xEDnh v\xE0 t\u1EF1 \u0111\u1ED9ng \u0111\u01B0\u1EE3c \u0111\u01B0a v\xE0o gi\xE1 b\xE1n theo quy t\u1EAFc gi\xE1`,
    priceSetting: `C\xE0i \u0111\u1EB7t gi\xE1 c\u1EA3`,
    priceSettingTip: `Quy t\u1EAFc gi\xE1 d\u1EF1a tr\xEAn gi\xE1 g\u1ED1c`,
    priceSettingDes1: `Gi\u1EEF nguy\xEAn gi\xE1 g\u1ED1c`,
    addByAmount: `Theo s\u1ED1 ti\u1EC1n t\u0103ng l\xEAn`,
    addByPercent: `Theo t\u1EF7 l\u1EC7 ph\u1EA7n tr\u0103m t\u0103ng l\xEAn`,
    reduceByAmount: `Theo s\u1ED1 ti\u1EC1n gi\u1EA3m xu\u1ED1ng`,
    reduceByPercent: `Theo t\u1EF7 l\u1EC7 ph\u1EA7n tr\u0103m gi\u1EA3m xu\u1ED1ng`,
    noChange: `Kh\xF4ng thay \u0111\u1ED5i`,
    cancel: `H\u1EE7y`,
    confirm: `X\xE1c nh\u1EADn`,
    amount: `S\u1ED1 l\u01B0\u1EE3ng`,
    scrapeList: `B\u1ED9 s\u01B0u t\u1EADp`,
    scrapeProducts: `S\u1EA3n ph\u1EA9m s\u01B0u t\u1EADp`,
    copyToChannel: `Ti\u1EBFp t\u1EE5c sao ch\xE9p \u0111\u1EBFn k\xEAnh`,
    editPublish: `\u0110\u0103ng ch\u1EC9nh s\u1EEDa`,
    productScraping: `S\u01B0u t\u1EADp s\u1EA3n ph\u1EA9m`,
    categoryScraping: `S\u01B0u t\u1EADp danh m\u1EE5c`,
    storeScraping: `S\u01B0u t\u1EADp c\u1EEDa h\xE0ng`,
    enterTip1: `Xin \u0111i\u1EC1n v\xE0o s\u1EA3n ph\u1EA9m URL, vui l\xF2ng s\u1EED d\u1EE5ng Enter \u0111\u1EC3 xu\u1ED1ng d\xF2ng, t\u1ED1i \u0111a 1000`,
    enterTip2: `Vui l\xF2ng nh\u1EADp ph\xE2n lo\u1EA1i website c\u1EE7a c\u1EEDa h\xE0ng, n\u1EBFu nhi\u1EC1u website vui l\xF2ng d\xF9ng Enter \u0111\u1EC3 xu\u1ED1ng d\xF2ng, t\u1ED1i \u0111a 100`,
    enterTip3: `Vui l\xF2ng \u0111i\u1EC1n link \u0111\u1ECBa ch\u1EC9 c\u1EE7a c\u1EEDa h\xE0ng Shopee, n\u1EBFu nhi\u1EC1u link vui l\xF2ng d\xF9ng Enter \u0111\u1EC3 xu\u1ED1ng d\xF2ng, t\u1ED1i \u0111a 100`,
    supportChannelsTip: `H\u1ED7 tr\u1EE3 k\xEAnh: `,
    collectSettings: `C\xE0i \u0111\u1EB7t nh\u1EADn`,
    scraping: `S\u01B0u t\u1EADp`,
    allScrapingSuccess: `S\u01B0u t\u1EADp th\xE0nh c\xF4ng t\u1EA5t c\u1EA3`,
    allScrapingFailed: `S\u01B0u t\u1EADp th\u1EA5t b\u1EA1i t\u1EA5t c\u1EA3`,
    someScrapingFailed: `S\u01B0u t\u1EADp th\xE0nh c\xF4ng m\u1ED9t ph\u1EA7n`,
    totalNumber: `T\u1ED5ng s\u1ED1 link`,
    successNumber: `S\u1ED1 l\u01B0\u1EE3ng th\xE0nh c\xF4ng`,
    failedNumber: `S\u1ED1 l\u01B0\u1EE3ng th\u1EA5t b\u1EA1i`,
    failedUrl: `Link th\u1EA5t b\u1EA1i`,
    validNumber: `Link h\u1EE3p l\u1EC7`,
    invalidNumber: `Link kh\xF4ng h\u1EE3p l\u1EC7`,
    scrapingFailed: `S\u1EA3n ph\u1EA9m s\u01B0u t\u1EADp th\u1EA5t b\u1EA1i`,
    productName: `T\xEAn s\u1EA3n ph\u1EA9m`,
    sku: `SKU`,
    productUrl: `S\u1EA3n ph\u1EA9m URL`,
    creator: `Ng\u01B0\u1EDDi t\u1EA1o`,
    pleaseEnterContent: `Vui l\xF2ng nh\u1EADp n\u1ED9i dung`,
    dataSources: `Ngu\u1ED3n d\u1EEF li\u1EC7u`,
    createTime: `Th\u1EDDi gian t\u1EA1o`,
    today: `H\xF4m nay`,
    weekly: `1 tu\u1EA7n g\u1EA7n \u0111\xE2y`,
    monthly: `1 th\xE1ng g\u1EA7n \u0111\xE2y`,
    yearly: `1 n\u0103m g\u1EA7n \u0111\xE2y`,
    reset: `Tr\u1ECDng l\u01B0\u1EE3ng`,
    all: `T\u1EA5t c\u1EA3`,
    notCollected: `Ch\u01B0a nh\u1EADn`,
    collected: `\u0110\xE3 nh\u1EADn`,
    price: `Gi\xE1 c\u1EA3`,
    noData: `T\u1EA1m th\u1EDDi kh\xF4ng c\xF3 d\u1EEF li\u1EC7u`,
    xDataSelected: `\u0110\xE3 ch\u1ECDn X d\u1EEF li\u1EC7u`,
    collect: `Nh\u1EADn`,
    delete: `X\xF3a`,
    operationGuide: `H\u01B0\u1EDBng d\u1EABn thao t\xE1c`,
    deleteTip1: `X\xE1c nh\u1EADn x\xF3a s\u1EA3n ph\u1EA9m \u0111\xE3 ch\u1ECDn trong B\u1ED9 s\u01B0u t\u1EADp`,
    deleteTip2: `S\u1EA3n ph\u1EA9m \u0111\xE3 ch\u1ECDn s\u1EBD kh\xF4ng b\u1ECB x\xF3a kh\u1ECFi k\xEAnh, b\u1EA1n vui l\xF2ng x\xF3a t\u1EF1 x\xF3a n\xF3`,
    ScrapingInProcess: `\u0110ang s\u01B0u t\u1EADp, vui l\xF2ng \u0111\u1EE3i.`,
    ClickTip: `Nh\u1EA5p v\xE0o n\u1ED9i dung trong b\u1EA3ng \u0111\u1EC3 ch\u1EC9nh s\u1EEDa`,
    productNameImage: `T\xEAn & h\xECnh \u1EA3nh s\u1EA3n ph\u1EA9m`,
    variantName: `T\xEAn Thu\u1ED9c t\xEDnh`,
    masterSKU: `SKU ch\xEDnh`,
    availableStock: `T\u1ED3n kho c\xF3 s\u1EB5n`,
    defaultPrice: `Gi\xE1 b\xE1n m\u1EB7c \u0111\u1ECBnh`,
    unitPurchasePrice: `\u0110\u01A1n gi\xE1 mua h\xE0ng`,
    action: `Thao t\xE1c`,
    discardChangeTip: `B\u1EA1n ch\u1EAFc ch\u1EAFn mu\u1ED1n b\u1ECF qua thay \u0111\u1ED5i n\xE0y?`,
    viewNow: `Xem ngay`,
    scrapeManagement: `Qu\u1EA3n l\xFD S\u01B0u t\u1EADp`,
    mskuExistsTip: `SKU ch\xEDnh \u0111\xE3 t\u1ED3n t\u1EA1i, vui l\xF2ng \u0111\u1EB7t t\xEAn l\u1EA1i`,
    collectedResultTip: `3 s\u1EA3n ph\u1EA9m \u0111\xE3 s\u01B0u t\u1EADp v\xE0o S\u1EA3n ph\u1EA9m ch\xEDnh`,
    deletedResultTip1: `X\xF3a th\xE0nh c\xF4ng`,
    deletedResultTip2: `\u0110\xE3 x\xF3a 65 d\u1EEF li\u1EC7u`,
    ScrapingInProcessDec: `C\xE1c s\u1EA3n ph\u1EA9m c\u1EE7a c\u1EEDa h\xE0ng \u0111ang \u0111\u01B0\u1EE3c s\u01B0u t\u1EADp, m\u1ED7i c\u1EEDa h\xE0ng s\u1EBD m\u1EA5t kho\u1EA3ng 10 ph\xFAt. B\u1EA1n c\xF3 th\u1EC3 ti\u1EBFp t\u1EE5c s\u01B0u t\u1EADp c\xE1c c\u1EEDa h\xE0ng kh\xE1c ho\u1EB7c v\xE0o B\u1ED9 s\u01B0u t\u1EADp \u0111\u1EC3 xem c\xE1c s\u1EA3n ph\u1EA9m \u0111\xE3 s\u01B0u t\u1EADp.`,
    continueToScrape: `Ti\u1EBFp t\u1EE5c s\u01B0u t\u1EADp`,
    collectToMasterProduct: `Nh\u1EADn v\xE0o S\u1EA3n ph\u1EA9m ch\xEDnh`,
    collectToMasterProductDec: `Sau khi nh\u1EADn S\u1EA3n ph\u1EA9m ch\xEDnh, \u0111\u0103ng n\xF3 l\xEAn c\u1EEDa h\xE0ng c\u1EE7a k\xEAnh \u0111\u1EC3 b\u1EA1n c\xF3 th\u1EC3 b\u1EAFt \u0111\u1EA7u qu\u1EA3n l\xFD gi\xE1 c\u1EA3 v\xE0 h\xE0ng t\u1ED3n kho`,
    autoCollectToMp: `T\u1EF1 \u0111\u1ED9ng nh\u1EADn v\xE0o S\u1EA3n ph\u1EA9m ch\xEDnh`,
    selectProducts: `Ch\u1ECDn nhi\u1EC1u s\u1EA3n ph\u1EA9m v\xE0 s\u01B0u t\u1EADp`,
    autoCollectToMpLimit: `Khi h\xE0ng t\u1ED3n kho c\u1EE7a s\u1EA3n ph\u1EA9m \u0111\u01B0\u1EE3c s\u01B0u t\u1EADp b\u1EB1ng 0, t\xEDnh n\u0103ng t\u1EF1 \u0111\u1ED9ng s\u01B0u t\u1EADp s\u1EBD kh\xF4ng \u0111\u01B0\u1EE3c h\u1ED7 tr\u1EE3`,
    inventorySkuLimit: `SKU ch\xEDnh t\u1ED1i \u0111a 50 k\xED t\u1EF1`,
    iskuCannotBeEmpty: `SKU ch\xEDnh kh\xF4ng \u0111\u01B0\u1EE3c \u0111\u1EC3 tr\u1ED1ng`,
    purchasePriceLimit: `Gi\xE1 n\xEAn t\u1EEB gi\u1EEFa 1-1000.000.000`,
    addAvailableStockLimit: `Ph\u1EA1m vi T\u1ED3n kho c\xF3 s\u1EB5n t\u1EEB 0-999.999`,
    productNameLimit: `T\xEAn s\u1EA3n ph\u1EA9m b\u1EAFt bu\u1ED9c t\u1EEB 1-300 k\xED t\u1EF1`,
    findSource: `T\xECm ngu\u1ED3n h\xE0ng`,
    editDec: `Ch\u1EC9nh s\u1EEDa v\xE0 \u0111\u0103ng t\u1EEB b\u1EA3n nh\xE1p c\u1EE7a c\u1EEDa h\xE0ng`,
    scrapeProduct: `S\u1EA3n ph\u1EA9m S\u01B0u t\u1EADp`,
    inputLinkTip: `Nh\u1EADp link \u0111\u1EC3 s\u01B0u t\u1EADp s\u1EA3n ph\u1EA9m`,
    collectToMasterDec: `Nh\u1EADn v\xE0 t\u1EA1o s\u1EA3n ph\u1EA9m ch\xEDnh h\xE0ng lo\u1EA1t`,
    copyToStoreTip2: `Sao ch\xE9p \u0111\u1EBFn c\u1EEDa h\xE0ng \u0111\u1EC3 b\xE1n`,
    copyToStoreTip3: `Ch\u1ECDn c\u1EEDa h\xE0ng v\xE0 sao ch\xE9p s\u1EA3n ph\u1EA9m ch\xEDnh \u0111\u1EBFn b\u1EA3n nh\xE1p trong c\u1EEDa h\xE0ng`,
    close: `\u0110\xF3ng`,
    allLinksInvalid: `T\u1EA5t c\u1EA3 link kh\xF4ng h\u1EE3p l\u1EC7, vui l\xF2ng ki\u1EC3m tra`,
    someLinksInvalid: `M\u1ED9t s\u1ED1 link kh\xF4ng h\u1EE3p l\u1EC7, vui l\xF2ng ki\u1EC3m tra`,
    viewMore: `Xem th\xEAm`,
    viewLess: `Thu g\u1ECDn`,
    faqName: `L\xE0m th\u1EBF n\xE0o \u0111\u1EC3 sao ch\xE9p s\u1EA3n ph\u1EA9m ch\xEDnh \u0111\u1EBFn c\u1EEDa h\xE0ng c\u1EE7a k\xEAnh?`,
    faqName1: `L\xE0m th\u1EBF n\xE0o \u0111\u1EC3 s\u01B0u t\u1EADp s\u1EA3n ph\u1EA9m t\u1EEB k\xEAnh Shopee?`,
    recommendToUseTheScrapePlugin: `\u01AFu ti\xEAn s\u1EED d\u1EE5ng c\xE0i \u0111\u1EB7t s\u01B0u t\u1EADp m\u1EDF r\u1ED9ng, t\xEDnh n\u0103ng s\u1EBD \u1ED5n \u0111\u1ECBnh v\xE0 nhanh h\u01A1n!`,
    recommendToUseTheScrapePluginTip1: `1. Tr\xECnh duy\u1EC7t \u0111\u1EC1 xu\u1EA5t: Google Chrome`,
    recommendToUseTheScrapePluginTip2: `2. \u0110\u1ECBa ch\u1EC9 c\xE0i \u0111\u1EB7t ti\u1EC7n \xEDch m\u1EDF r\u1ED9ng:`,
    recommendToUseTheScrapePluginTip2Sub: `\u0110i \u0111\u1EBFn c\u1EEDa h\xE0ng Google \u0111\u1EC3 c\xE0i \u0111\u1EB7t`,
    recommendToUseTheScrapePluginTip3: `3. N\u1EBFu kh\xF4ng th\u1EC3 truy c\u1EADp Google Store, h\xE3y t\u1EA3i ti\u1EC7n \xEDch m\u1EDF r\u1ED9ng t\u1EA1i \u0111\xE2y:`,
    recommendToUseTheScrapePluginTip3Sub: `T\u1EA3i xu\u1ED1ng v\xE0 c\xE0i \u0111\u1EB7t Ti\u1EC7n \xEDch m\u1EDF r\u1ED9ng`,
    recommendToUseTheScrapePluginTip4: `4. V\u1EC1 c\xE1ch s\u1EED d\u1EE5ng ti\u1EC7n \xEDch m\u1EDF r\u1ED9ng, vui l\xF2ng tham kh\u1EA3o:`,
    recommendToUseTheScrapePluginTip4Sub: `H\u01B0\u1EDBng d\u1EABn s\u1EED d\u1EE5ng`,
    pluginScraping: `S\u01B0u t\u1EADp m\u1EDF r\u1ED9ng`,
    scrapeSuccess: `S\u01B0u t\u1EADp th\xE0nh c\xF4ng`,
    scrapeFailedPleaseCheckLinkOr: `S\u01B0u t\u1EADp th\u1EA5t b\u1EA1i, vui l\xF2ng ki\u1EC3m tra link ho\u1EB7c th\u1EED l\u1EA1i sau`,
    installTheTutorial: `H\u01B0\u1EDBng d\u1EABn c\xE0i \u0111\u1EB7t`
  }
};
